import { create } from "zustand";

/**
 * Обложка модели из визуализатора (замечание Сергея № 29).
 *
 * Сотрудник в публикации модели нажимает «Сделать обложку визуализатором»:
 * кабинет закрывается, открывается визуализатор. Рендер, отмеченный
 * «Поставить обложкой модели», возвращается в публикацию, кабинет снова
 * открывается. Закрыли визуализатор без выбора — просто возвращаемся.
 */
interface CatalogCoverState {
  requested: boolean;
  cover: string | null;
  request: () => void;
  deliver: (cover: string) => void;
  cancel: () => void;
  take: () => string | null;
}

export const useCatalogCover = create<CatalogCoverState>((set, get) => ({
  requested: false,
  cover: null,
  request: () => set({ requested: true, cover: null }),
  deliver: (cover) => set({ requested: false, cover }),
  cancel: () => { if (get().requested) set({ requested: false }); },
  take: () => {
    const cover = get().cover;
    if (cover) set({ cover: null });
    return cover;
  }
}));
